import {NotificationService} from './../../services/notification.service';
import {first, map} from 'rxjs/operators';
import {AuthService} from 'src/app/services/auth.service';
import {ActivatedRoute, Router} from '@angular/router';
import {Component, OnInit} from '@angular/core';
import {Form, FormBuilder, FormGroup, Validators} from "@angular/forms";
import {Store} from "@ngrx/store";
import {AppState} from "../../store/reducers";
import {activateAccount} from "../../store/entities/uaa-setting/activate-account/activate-account.actions";
import {passwordPolicyValidator} from "../../shared/validators/input-validators";

@Component({
  selector: 'app-activate-account',
  templateUrl: './activate-account.component.html',
  styleUrls: ['./activate-account.component.scss'],
})
export class ActivateAccountComponent implements OnInit {
  token: string;
  formData: FormGroup
  showPassword: boolean = false;
  showPassword1: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private store: Store<AppState>,
    private fb: FormBuilder,
    private notificationService: NotificationService
  ) {

  }

  async ngOnInit() {
    this.token = this.route.snapshot.paramMap.get('activationToken');
    this.formData = this.fb.group({
      password: [null, [Validators.required, passwordPolicyValidator()]],
      confirmPassword: [null, [Validators.required, passwordPolicyValidator()]],
    })
  }

  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }

  togglePasswordVisibility1() {
    this.showPassword1 = !this.showPassword1;
  }

  submitForm(formData?: any){
    console.log(this.token);
    if(this.token){
      if(formData?.password === formData?.confirmPassword){
        this.store.dispatch(activateAccount({
          input: {
            token: this.token,
            password: formData?.password
          }
        }))
        this.router.navigate(['/login'])

      } else {
        this.notificationService.errorMessage("Passwords do not match")
      }
    }
  }

}
